// v10/src/services/notificationPreferencesService.js
//
// Servicios de A6.2 — preferencias de notificación por usuario logueado
// y dashboard de alertas/mantenimiento para el admin (parte 2A backend).
//
// Wrapper del axios `api` que ya maneja JWT, refresh automático e
// impersonación de SuperAdmin (incluye `org_id` como query param cuando
// `window.__condor360_impersonate_org_id` está seteado, así que no hace
// falta pasarlo a mano acá).

import api from './apiService';

export const notificationPreferencesService = {
  // GET /api/users/me/notification-preferences
  // Si el user no tiene fila propia, devuelve defaults con is_default:true.
  getMy: () => api.get('/api/users/me/notification-preferences'),

  // PUT /api/users/me/notification-preferences
  // Acepta cualquier subset de:
  //   email_daily_summary, push_threshold_crossed, push_aog_alerts,
  //   email_aog_alerts, min_threshold_to_notify ('next'|'critical'|'expired')
  updateMy: (prefs) => api.put('/api/users/me/notification-preferences', prefs),
};

export const alertsService = {
  // GET /api/admin/alerts/dashboard
  // Para superadmin impersonando, el interceptor agrega org_id automáticamente.
  // Si en algún call site se necesita override explícito, se acepta orgId.
  getDashboard: (orgId = null) => {
    const params = orgId ? { org_id: orgId } : undefined;
    return api.get('/api/admin/alerts/dashboard', params ? { params } : undefined);
  },
};

export default notificationPreferencesService;
